import React from 'react';
import { motion } from 'framer-motion';
import type { PeekInsideSlide } from '../../data/peekInsideSlides';
type CoverflowStageProps = {
  slides: PeekInsideSlide[];
  active: number;
  reduceMotion: boolean;
  onSelect: (index: number) => void;
  onOpen: (index: number) => void;
};
const ease = [0.23, 1, 0.32, 1] as const;
export function CoverflowStage({
  slides,
  active,
  reduceMotion,
  onSelect,
  onOpen
}: CoverflowStageProps) {
  const n = slides.length;
  return <div className="relative mx-auto aspect-[4/5] w-[min(400px,40vw)] lg:w-[420px]" data-id="element-149" data-mp="2phki7ut1r81i">
      {slides.map((slide, i) => {
      let offset = i - active;
      if (offset > n / 2) offset -= n;
      if (offset < -n / 2) offset += n;
      const abs = Math.abs(offset);
      const isActive = abs === 0;
      const visible = abs <= 1;
      return <motion.button key={slide.src} type="button" tabIndex={visible ? 0 : -1} aria-hidden={!visible} aria-label={isActive ? `Open full size: ${slide.caption}` : `Show page ${i + 1}: ${slide.caption}`} onClick={() => isActive ? onOpen(i) : onSelect(i)} className={`absolute inset-0 overflow-hidden rounded-[12px] border border-gold/40 bg-plum-deep shadow-[0_24px_60px_-24px_rgba(232,170,80,0.45),0_8px_20px_-8px_rgba(0,0,0,0.7)] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-4 focus-visible:ring-offset-plum-deep ${isActive ? 'cursor-zoom-in' : 'cursor-pointer'}`} style={{
        zIndex: 10 - abs,
        pointerEvents: visible ? 'auto' : 'none'
      }} initial={false} animate={{
        x: `${offset * 74}%`,
        scale: isActive ? 1 : visible ? 0.8 : 0.66,
        opacity: isActive ? 1 : visible ? 0.4 : 0
      }} transition={reduceMotion ? {
        duration: 0
      } : {
        duration: 0.3,
        ease
      }} data-id="element-150" data-mp="1011o0o4hee3m" data-mpi={i}>
            <img src={slide.src} alt={slide.alt} width={1560} height={1950} loading={isActive ? 'eager' : 'lazy'} draggable={false} className="h-full w-full object-contain" data-id="element-151" data-mp="w9lf6xhjnw8n" />
          </motion.button>;
    })}
    </div>;
}